/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useCallback } from 'react';
import { Space } from 'antd';
import identity from 'lodash/identity';

import { FULL_WIDTH } from '@constants';

import Button from '../Button';
import Select from '../Select';

const SelectAction = ({
  gutter = 10,
  options = [],
  disabled,
  buttonTitle,
  buttonOnClick,
  buttonType,
  buttonDisabled = disabled,
  transformOption = identity,
  ...props
}) => {
  const [actionValue, setValue] = useState(null);
  const handleClick = useCallback(() => buttonOnClick(actionValue), [actionValue, buttonOnClick]);

  return (
    <Space size={gutter} direction="vertical" style={FULL_WIDTH}>
      <Select
        labelInValue
        disabled={disabled}
        style={FULL_WIDTH}
        onChange={setValue}
        dropdownMatchSelectWidth={false}
        {...props}
      >
        {options.map((option) => {
          const { id, name } = transformOption(option);
          return (
            <Select.Option key={id} value={id}>
              {name}
            </Select.Option>
          );
        })}
      </Select>
      <Button disabled={buttonDisabled} type={buttonType} block onClick={handleClick}>
        {buttonTitle}
      </Button>
    </Space>
  );
};

export default SelectAction;
